export default class SyncStorage<T = unknown> {
  get(key: string): T | null {
    const value = getLocalStorage().getItem(key)
    if (!value) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- FIXME: Fix this ESLint violation!
      return value as any
    }
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- FIXME: Fix this ESLint violation!
      return JSON.parse(value)
    } catch {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- FIXME: Fix this ESLint violation!
      return value as any
    }
  }

  set(key: string, item: any) {
    if (typeof item === 'string') {
      getLocalStorage().setItem(key, item)
    } else {
      getLocalStorage().setItem(key, JSON.stringify(item))
    }
  }

  delete(key: string) {
    getLocalStorage().removeItem(key)
  }
}

const fallbackLocalStorageStore: Record<string, string | null> = {}
const fallbackLocalStorage = {
  getItem: (key: string) => fallbackLocalStorageStore[key] ?? null,
  setItem: (key: string, value: string) => {
    fallbackLocalStorageStore[key] = value
  },
  removeItem: (key: string) => {
    delete fallbackLocalStorageStore[key]
  },
}

function getLocalStorage() {
  if (import.meta.env.TEST && (typeof window === 'undefined' || !window.localStorage)) {
    return fallbackLocalStorage
  }

  return window.localStorage
}
